export default __webpack_public_path__ + "static/iam_role_04-1883276089aa02d97c3e428b8211263f.png";